<template>
  <component
    :is="layout"
    v-if="layout"
  >
    <router-view />
  </component>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import UpdateDialog from '@/components/UpdateDialog.vue'
import { SplashScreen } from '@capacitor/splash-screen'
import { installKeyboardScroll } from '@/utils/keyboardScroll'
import { Keyboard } from '@capacitor/keyboard'

export default defineComponent({
  components: { UpdateDialog },
  data() {
    return {
      keyboardHeight: 0,
    }
  },
  head: {
    titleTemplate: '%s | WashWerk',
  },
  computed: {
    layout() {
      if (!this.$route) return null
      return this.$route.meta?.layout ? this.$route.meta.layout + 'Layout' : 'EmptyLayout'
    },
  },
  watch: {
    keyboardHeight: {
      handler(newHeight: string) {
        document.documentElement.style.setProperty('--keyboard-height', newHeight + 'px')
      },
      immediate: true,
    },
  },
  async mounted() {
    if (this.$capacitor.isNativePlatform()) {
      await SplashScreen.hide()
      installKeyboardScroll()
      await Keyboard.addListener('keyboardWillShow', (info) => {
        this.keyboardHeight = info.keyboardHeight
      })
      await Keyboard.addListener('keyboardWillHide', () => {
        this.keyboardHeight = 0
      })
    }
  },
  beforeUnmount(): any {
    if (this.$capacitor.isNativePlatform()) {
      Keyboard.removeAllListeners()
    }
    document.documentElement.style.removeProperty('--keyboard-height')
  },
})
</script>
